import './cover.css';
// import Batumi from '../Assets/batumi12.png';
import { Carousel } from 'react-carousel-minimal';

import c1 from '../Assets/c1.jpeg';
import c2 from '../Assets/c2.jpeg';
import c3 from '../Assets/c3.jpeg';
import c4 from '../Assets/c4.jpeg';
import c5 from '../Assets/c5.JPG';
import { red } from '@mui/material/colors';
import { Crop169Sharp } from '@mui/icons-material';
export default function Cover() {
  const data = [
    {
      //   image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/GoldenGateBridge-001.jpg/1200px-GoldenGateBridge-001.jpg",
      image: c1,
      //caption: `<p>თანამედროვე და ტრადიციული ქორეოგრაფია</p>`
    },
    {
      image: c2,
      //caption: `<p>სასწავლო კურსების მრავალფეროვანი არჩევანი</p>`
    },
    {
      image: c3,
      //caption: ` <p>სახვითი და გამოყენებითი ხელოვნება</p>`
    },
    {
      image: c4,
      //caption: `<p>თეატრი და მუსიკა</p>`
    },
    {
      image: c5,
      //caption: `<p>გრაფიკული დიზაინი</p>`
    },
    // {
    //   image: Office1,
    // //   caption: "Darjeeling"
    // },
    //{
    //  image: Code6,
    //  caption: `<p>საუკეთესო სერვისი</p>`
    //},
    // {
    //   image: "https://images.ctfassets.net/bth3mlrehms2/6Ypj2Qd3m3jQk6ygmpsNAM/61d2f8cb9f939beed918971b9bc59bcd/Scotland.jpg?w=750&h=422&fl=progressive&q=50&fm=jpg",
    // //   caption: "Scotland"
    // },
    // {
    //   image: "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/02/summer-7.jpg",
    // //   caption: "Darjeeling"
    // }
  ];

  const captionStyle = {
    fontSize: '1.7em',
    fontWeight: 'bold',
    backgroundColor: 'rgba(0,0,0,0.7)',
    width: '50%',
    marginLeft: '25%',
    padding: '0.05em',
    borderRadius: '0.8em',
  }
  //   const slideNumberStyle = {
  //     fontSize: '20px',
  //     fontWeight: 'bold',
  //   }

  return (
    <div>
      {/* <img className='img-batumi' src={Batumi}/> */}
      <div style={{ textAlign: 'center' }}>
        <div
          style={
            {
              //   padding: "0 20px"
            }
          }
        >
          <Carousel
            data={data}
            time={3000}
            width='100%'
            height='600px'
            //captionStyle={captionStyle}
            // radius="10px"
            // slideNumber={true}
            // slideNumberStyle={slideNumberStyle}
            captionPosition='top'
            automatic={true}
            dots={true}
            pauseIconColor='white'
            pauseIconSize='40px'
            slideBackgroundColor='black'
            slideImageFit='cover'
            // thumbnails={true}
            // thumbnailWidth="100px"
            style={{
              textAlign: 'center',
              //   maxWidth: "850px",
              //   maxHeight: "500px",
              //   margin: "auto",
            }}
          />
        </div>
      </div>
    </div>
  );
}
